// CSS Modules - component class name prefix: BranchApp__

<template />

<script>
import smoothscroll from "smoothscroll-polyfill";
import "svg-classlist-polyfill";
smoothscroll.polyfill();

export default {
    name: "BranchApp",
    data() {
        return {
            keys: {}
        };
    },
    methods: {
        /* filter product list */
        filterProducts(product){
            if (product) {
                /* Create event productFilter */
                const productFilter = new CustomEvent("updateFilter", {
                    detail: { id: product }
                });
                /* Trigger event productFilter */
                window.dispatchEvent(productFilter);
            } else {
                /* Create event resetFilter */
                const resetFilter = new CustomEvent("updateFilter", {
                    detail: { id: "all" }
                });
                /* Trigger event reset */
                window.dispatchEvent(resetFilter);
            }
        },
        /* reset active links */
        resetActiveLink(parent, reset){
            const resetFilter = reset ? reset : false;
            const elms = document.getElementById(parent).getElementsByClassName("BranchApp__svg-drop-active");
            for(let i = 0; i < elms.length; i++ ){
                elms[i].classList.remove("BranchApp__svg-drop-active");
            }
            if (resetFilter) {
                this.filterProducts();
            }
        },
        /* acitvate links */
        activateLink(id, resultSize, randomId, section){
            let parent = "BranchApp__svg-imagemap-" + randomId;
            let scrollToId = "BranchApp__products-" + randomId;
            let reset = (id === null);
            this.resetActiveLink(parent, reset);
            if (resultSize != null) {
                document.getElementById("BranchApp__productCount-" + randomId).textContent = resultSize.toString();
                if (!reset) {
                    this.filterProducts(id);
                }
            }
            if (section != null) {
                const sectionNodes = document.getElementsByClassName("BranchApp__section");
                for(let i = 0; i < sectionNodes.length; i++ ){
                    let sectionNode = sectionNodes[i];
                    if (sectionNode.getAttribute("data-section") == section) {
                        sectionNode.classList.remove("BranchApp__hide");
                        this.initSvg();
                        scrollToId = "BranchApp__scroll-" + section;
                    } else {
                        sectionNode.classList.add("BranchApp__hide");
                    }
                }
            }
            if (!reset) {
                document.getElementById("BranchApp__svg-link-" + id).getElementsByTagName("use")[0].classList.add("BranchApp__svg-drop-active");
                if (resultSize != null || section != null) {
                    document.getElementById(scrollToId).scrollIntoView({ behavior: "smooth" });
                }
            }
        },
        initActivateLink() {
            const linkNodes = document.getElementsByClassName("BranchApp__activateLink");
            for(let i = 0; i < linkNodes.length; i++ ) {
                let node = linkNodes[i];
                if (!node.classList.contains("activateLink-initialized")) {
                    const activateLinkEvent = (e) => {
                        let target = e.currentTarget;
                        /* prevent default link behavior */
                        e.preventDefault();
                        /* call activateLink function with data attributes */
                        let id = target.getAttribute("data-id") || null;
                        let resultSize = target.getAttribute("data-result-size") || null;
                        let randomId = target.getAttribute("data-random-id") || null;
                        let section = target.getAttribute("data-section") || null;
                        this.activateLink(id, resultSize, randomId, section);
                    };
                    node.addEventListener("click", activateLinkEvent, false);
                    node.classList.add("activateLink-initialized");
                }
            }
        },
        /* init svg imagemap */
        initSvg() {
            /* resize and move tooltip to it's position */
            const supported = document.implementation.hasFeature("www.http://w3.org/TR/SVG11/feature#Extensibility","1.1");
            const linkNodes = document.getElementsByClassName("BranchApp__svg-info");
            for(let i = 0; i < linkNodes.length; i++ ){
                let nodeId = linkNodes[i].getAttribute("data-id");
                let pathNode = document.getElementById("BranchApp__svg-tt-path-" + nodeId);
                /* define position and height */
                let pNodeH = 0;
                if (supported) {
                    pNodeH = document.getElementById("BranchApp__svg-p-" + nodeId).offsetHeight + 5;
                } else {
                    pNodeH = document.getElementById("BranchApp__old-browser-text-" + nodeId).getBBox().height + 10;
                }
                let newPNodeY = - pNodeH - 45;
                /* adjust tooltip */
                linkNodes[i].setAttribute("transform", "matrix(1,0,0,1,-100,"+newPNodeY+")");
                pathNode.setAttribute("d", "M0 0 h200 v"+pNodeH+" h-90 l-10 5 l-10 -5 h-90 Z");
            }
            /* clear viewport for links */
            const resizeNodes = document.getElementsByClassName("BranchApp__svg-resize");
            for(let i = 0; i < resizeNodes.length; i++ ){
                let parentNodeId = resizeNodes[i].getAttribute("data-id");
                let parentNode = document.getElementById(parentNodeId);
                let h = parentNode.clientHeight;
                let w = parentNode.clientWidth;
                resizeNodes[i].setAttribute("viewBox", "0 0 "+w+" "+h);
            }
        },
        /* init scroll function */
        initScroll() {
            if ("querySelector" in document && "addEventListener" in window) {
                /* find all scroll links and add event handler */
                let scrollLinks = document.getElementsByClassName("scroll");
                for(let i = 0; i < scrollLinks.length; i++ ){
                    if (!scrollLinks[i].classList.contains("scroll-is-initialized")) {
                        let scrollLinkHref = scrollLinks[i].getAttribute("href");
                        let scrollLinkTarget = document.querySelector(scrollLinkHref);
                        if (scrollLinkTarget) {
                            const scrollEvent = (e) => {
                                let target = e.currentTarget;
                                /* prevent default link behavior */
                                e.preventDefault();
                                /* call scroll function to scrollTarget */
                                let scrollTargetID = target.getAttribute("href");
                                let scrollTarget = document.querySelector(scrollTargetID);
                                if (scrollTarget) {
                                    scrollTarget.scrollIntoView({ behavior: "smooth" });
                                }
                            };
                            scrollLinks[i].addEventListener("click", scrollEvent, false);
                            scrollLinks[i].classList.add("scroll-is-initialized");
                        }
                    }
                }
            }
        },
        /* init tabs */
        initTabs() {
            let tabs = document.getElementsByClassName("BranchApp__tabContainer");
            for(let i = 0; i < tabs.length; i++ ){
                if (!tabs[i].classList.contains("tab-is-initialized")) {
                    const activateSvg = (e) => {
                        this.initSvg();
                    };
                    tabs[i].addEventListener("click", activateSvg, false);
                    tabs[i].classList.add("tab-is-initialized");
                }
            }
        }
    },
    mounted() {
        /* used for disable user scrolling temporarily -> spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36 */
        this.keys = {
            37: 1,
            38: 1,
            39: 1,
            40: 1
        };
        this.initSvg();
        this.initActivateLink();
        this.initScroll();
        this.initTabs();
        window.addEventListener("resize", this.initSvg);
    },
    destroyed() {
      window.removeEventListener("resize", this.initSvg);
    }
};
</script>

<style module lang="scss">
@import "./BranchApp.scss";
</style>
